"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = require("styled-components");
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var defaultState = {
  wrapper: (0, _styledComponents.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\n    "], ["\n\n    "]))),
  element: (0, _styledComponents.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n    "], ["\n    \n    "]))),
  input: (0, _styledComponents.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n    "], ["\n    \n    "])))
};
var error = {
  wrapper: (0, _styledComponents.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        && {\n            color: #FF0000;\n        }\n    "], ["\n        && {\n            color: #FF0000;\n        }\n    "]))),
  element: (0, _styledComponents.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        &--left {\n            border-color: #FF0000;\n            border-style: solid;\n            border-width: 1px 0 1px 1px;\n        }\n\n        &--right {\n            border-color: #FF0000;\n            border-style: solid;\n            border-width: 1px 1px 1px 0px;\n        }\n    "], ["\n        &--left {\n            border-color: #FF0000;\n            border-style: solid;\n            border-width: 1px 0 1px 1px;\n        }\n\n        &--right {\n            border-color: #FF0000;\n            border-style: solid;\n            border-width: 1px 1px 1px 0px;\n        }\n    "]))),
  input: (0, _styledComponents.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        ", "\n\n        ", "\n    "], ["\n        ", "\n\n        ", "\n    "])), function (_a) {
    var $elements = _a.$elements;
    return $elements.left === 'element' && (0, _styledComponents.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n            border-left: 0;\n        "], ["\n            border-left: 0;\n        "])));
  }, function (_a) {
    var $elements = _a.$elements;
    return $elements.right === 'element' && (0, _styledComponents.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n            border-right: 0;\n        "], ["\n            border-right: 0;\n        "])));
  })
};
var states = {
  default: defaultState,
  error: error
};
var _default = states;
exports.default = _default;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;